import globalPageStyle from '../css/globalPage.module.scss';
import { useTranslation } from 'react-i18next';

const Dashboard = () => {
  const { t } = useTranslation();

  return (
    <main className={globalPageStyle.pageContainer}>
      <div className={globalPageStyle.pageContent}>{t('dashboard.title')}</div>
    </main>
  );
};

export default Dashboard;
